import { Component, input, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaisyAvatarComponent, DaisyTooltipDirective } from '@pathfinder/daisy-controls/ui';
import { NotificationService } from '@lib/notification/data-access';
import { NotificationModel, NotificationGroupModel } from '@lib/notification/models';
import { ToastMessageService } from '@lib/shared/data-access';
import { RouterModule } from '@angular/router';
import { RouterLinkSafeUrlPipe, TimeAgoPipe } from '@lib/shared/util';
@Component({
  selector: 'lib-notification-feature-alarm-notification-template',
  standalone: true,
  imports: [
    RouterLinkSafeUrlPipe,
    CommonModule,
    RouterModule,
    TimeAgoPipe,
    DaisyAvatarComponent,
    DaisyTooltipDirective,
  ],
  templateUrl: './notification-alarm-notification-template.component.html',
  styleUrls: ['./notification-alarm-notification-template.component.scss'],
})
export class NotificationAlarmNotificationTemplateComponent {
  // inject
  private notificationService = inject(NotificationService);
  private toastMessageService = inject(ToastMessageService);
  
  public groupedNotifications = input.required<NotificationGroupModel>();

  /** Whether the "similar notifications" list is open. */
  public isExpanded = signal(false);

  /** The tooltip for the linked entity, read off its URL, as the template's inline ternary had it. */
  public entityLinkTooltip(url: string | null | undefined): string {
    if (url?.includes('organizations')) {
      return 'Navigate to Organization';
    }
    return url?.includes('incidents') ? 'Navigate to Incident' : 'Navigate to Person';
  }

  /** The matching icon: a building, an incident report, otherwise a person. */
  public entityLinkIcon(url: string | null | undefined): string {
    if (url?.includes('organizations')) {
      return 'fa-building';
    }
    return url?.includes('incidents') ? 'fa-file-lines' : 'fa-user';
  }

  public onHyperLinkClick(notification: NotificationModel, $event: MouseEvent) {
    if ($event) $event.stopPropagation();

    this.onMarkNotificationsReadStatusesClick(notification, true, $event);
  }

  // accessibility only --start--
  public onMarkNotificationsReadStatusesClick(notifications: NotificationModel[] | NotificationModel, markAsRead: boolean, event?: MouseEvent) {
    if (event) event.stopPropagation();

    // Ensure notifications is always treated as an array
    const notificationsArray = Array.isArray(notifications) ? notifications : [notifications];

    // Filter out any notifications without an id and update their read status
    const updatedNotifications = notificationsArray.filter(notification => notification.id !== undefined);

    updatedNotifications.forEach(notification => {
      notification.isRead = markAsRead;
    });

    if (updatedNotifications.length > 0) {
      this.notificationService.updateNotificationsStatus(updatedNotifications).subscribe({
        error: () => this.toastMessageService.showError("Error updating notification status.")
      });
    }
  }
}
